import classNames from 'classnames/bind';
import { useField } from 'formik';
import React from 'react';

import type { IInput } from './Input';
import { InputGroup } from './InputGroup';
import { ScrollToError } from '@containers/Form/ScrollToError/ScrollToError';

import styles from './Input.module.scss';

export interface IProps extends IInput {
  name: string;
  placeholder?: React.InputHTMLAttributes<HTMLInputElement>['placeholder'];
  tooltipText?: string;
  rows?: number;
  disableErrorScroll?: boolean;
}

const cx = classNames.bind(styles);

export const TextArea: React.FC<IProps> = ({
  id,
  name,
  label,
  placeholder,
  required,
  testId,
  optional,
  className,
  tooltipText,
  disableErrorScroll,
  rows = 5,
  validate,
}) => {
  const [field, meta] = useField({ name, validate });
  const inputRef = React.useRef(null);

  return (
    <>
      {!disableErrorScroll && <ScrollToError inputRef={inputRef} name={name} />}
      <InputGroup
        className={className}
        error={meta.error}
        id={id}
        label={label}
        optional={optional}
        required={required}
        testId={testId ?? name}
        tooltipText={tooltipText}
        touched={meta.touched}
        value={field.value}
      >
        <textarea
          {...field}
          ref={inputRef}
          className={cx('textarea', {
            inputError: meta.touched && meta.error,
          })}
          data-testid={testId ?? name}
          id={id}
          placeholder={placeholder}
          rows={rows}
        />
      </InputGroup>
    </>
  );
};
